export default "__VITE_ASSET__54baeb24__"